require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-international.json") })
        }
      }, "path---es-articles-tags-international");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-international!./.cache/json/es-articles-tags-international.json
// module id = 2360
// module chunks = 231608221292675